"use strict";

exports.__esModule = true;
exports.MapOperatorUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MapOperatorUserActionElement = require("./MapOperatorUserActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapOperatorUserAction = exports.MapOperatorUserAction = {
  name: "MapOperator",
  icon: "cog",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapOperatorUserAction.label",
    defaultMessage: "Map Operator"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapOperatorUserAction.description",
    defaultMessage: "Define operator mapping"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _MapOperatorUserActionElement.MapOperatorActionElement
  }
};